$(document).on('click', '.form-group.explicit_edit .click-area', function(e) {
  let input = e.currentTarget.querySelector('input[disabled]');
  if(!input) return;

  input.value = input.disabled = null;
  input.focus();
})
